import { Component, OnInit } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip, Color } from 'ng2-charts';

@Component({
  selector: 'app-dangerous-material',
  templateUrl: './dangerous-material.component.html',
  styleUrls: ['./dangerous-material.component.scss']
})
export class DangerousMaterialComponent implements OnInit {

  // Pie
  public pieChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true
    }
  };
  // public pieChartLabels: Label[] = [['Download', 'Sales'], ['In', 'Store', 'Sales'], 'Mail Sales'];
  public pieChartLabels: Label[] = ['Cat. 1', 'Cat. 2', 'Cat. 3',];
  public pieChartData: SingleDataSet = [300, 500, 100];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors: Color[] = [
    {
      backgroundColor: [
        'rgba(255, 217, 0, 0.8)',
        'rgba(255, 115, 0, 0.8)',
        'rgba(255, 0, 0, 0.8)'
      ],
    }
  ];

  constructor() { }

  ngOnInit() {
  }

}
